export default "Syng sammen, bevæg jer og spil med på Ask & Liv-sangen ”På vildspor”.\n\n**Denne aktivitet kan også laves ude.**\n";